import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ErrorHandler, APP_INITIALIZER, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GlobalErrorHandler } from './core/handlers/global-error.handler';
import { DashboardModule } from './dashboard/dashboard.module';
import { ErrorModule } from './error/error.module';
import { AuthClientConfig, AuthModule } from '@auth0/auth0-angular';
import { AuthService } from './core/auth/auth.service';
import { ConfigService } from './core/services/config.service';
import { AuthInterceptor } from './core/auth/auth.interceptor';

export function appInitializer(
  configService: ConfigService,
  authClientConfig: AuthClientConfig,
  injector: Injector
) {
  return () =>
    configService.loadConfig().then(config => {
      authClientConfig.set({
        domain: config.Auth0domain,
        clientId: config.Auth0clientId,
        authorizationParams: {
          redirect_uri: config.Auth0redirect_uri,
          audience: config.Auth0audience,
          organization: config.Auth0organizationId
        }
      });
      const authService = injector.get(AuthService);
      return authService.initAuth();
    });
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    CoreModule,
    FormsModule,
    DashboardModule,
    ErrorModule,
    AuthModule.forRoot({
      domain: '',
      clientId: '',
      authorizationParams: {
        redirect_uri: '',
        audience: '',
        organization: ''
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true
    })
  ],
  providers: [
    AuthService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [ConfigService, AuthClientConfig, Injector],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}